import React from 'react';
import { LinkButton } from '@eika/button';
import { useSiteLang, useTranslation } from '../common/util/Hook';

export const LanguageSelector = (): React.ReactElement => {
    const { siteLang, setSiteLang } = useSiteLang();
    const translated = useTranslation()
    const handleLanguageToggle = (): void => {
        setSiteLang(siteLang === 'nb' ? 'en' : 'nb');
    };

    return (
        <div>
            <LinkButton onClick={handleLanguageToggle}>{translated.skiftSpraak}</LinkButton>
        </div>
    );
};
